import { ShippingMethod } from '@eshop/types/shipping.types.ts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapApiToShipping = (api: any): ShippingMethod => ({
  id: api.id,
  name: api.nombre ?? api.name ?? '',
  limite_envio_gratis: api.limite_envio_gratis ?? 0,
  calculated_cost: {
    incl_tax: api.calculated_cost?.incl_tax ?? api.price?.incl_tax ?? api.base_cost ?? null,
    excl_tax: api.calculated_cost?.excl_tax ?? api.price?.excl_tax ?? null,
    currency: api.calculated_cost?.currency ?? api.price?.currency ?? api.currency ?? 'ARS',
  },
  codigo: api.codigo ?? api.code ?? undefined,
  code: api.code ?? api.codigo ?? undefined,
  strategy: api.strategy ?? api.tipo ?? undefined,
  is_default: api.is_default ?? false,
  image: api.image,
  is_active: api.is_active ?? '0',
  metodo_pago: api.metodo_pago ?? 0,
  precio_x_item: api.precio_x_item ?? null,
  precio_x_pedido: api.precio_x_pedido ?? null,
  tipo_envio: api.tipo_envio ?? 0,
  descripcion: api.descripcion ?? api.description,
  is_fallback: api.is_fallback ?? false,
  fallback_reason_code: api.fallback_reason_code ?? null,
});
